<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-top="400"
    :nudge-right="55"
    offset-y
    open-on-hover
  >
    <template v-slot:activator="{ on }">
      <v-avatar
        color="teal"
        class="mx-2"
        v-on="on"
      >
        <img 
          v-if="employee.thumbnail_url"
          :src="employee.thumbnail_url" 
          alt="avatar"
        >
        <span 
          v-else 
          class="white--text headline"
        >{{ employee.person.name.match(/\b\w/g).slice(0, 1).join('') }}
        </span>
      </v-avatar>  
    </template>

    <v-card max-width="350px">
      <v-container
        fluid
        class="pa-6"
      >
        <v-row
          justify="center"
          align="center"
        >
          <v-avatar
            class="ma-3"
            size="125"
            tile
          >
            <v-img
              max-height="180"
              max-width="180"
              :src="employee.thumbnail_url" 
              alt="avatar"
            />
          </v-avatar>  
        </v-row>

        <v-card-title class="subtitle-1 font-weight-medium justify-center">
          {{ employee.person.name }}
        </v-card-title>

        <v-card-subtitle class="text-center">
          {{ city.name }}, {{ city.state.name }}
        </v-card-subtitle>

        <v-row
          justify="center"
          align="center"
        >
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">
                    Start Date
                  </th>
                  <th class="text-left">
                    End Date
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="item in leaveApplications"
                  :key="item.id"
                >
                  <td>{{ item.start_date }}</td>
                  <td>{{ item.end_date }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>  
        </v-row>   
      </v-container>
      <v-divider />
    </v-card>
  </v-menu>
</template>

<script>
  export default {
    props: {
      employee: {
        type: Object,
        required: true,
      },
      leaveApplications: {
        type: Array,
        required: true,
      },
      city: {
        type: Object,
        required: true,
      },
    },
    data: () => ({
      menu: false,
    }),
  }
</script>
